import Pages from "layouts/Pages/Pages.jsx";
import Dashboard from "layouts/Dashboard/Dashboard.jsx";

var indexRoutes = [
  { path: "/dashboard", name: "Home", component: Dashboard },
  { path: "/", name: "Pages", component: Pages }
];

export default indexRoutes;
